import type { MessagingCreateChatRoom201LastMessageBasicInfoAllOfTwoType } from './messagingCreateChatRoom201LastMessageBasicInfoAllOfTwoType';

/**
 * 메시지 기본 정보
 */
export type MessagingCreateChatRoom201LastMessageBasicInfoAllOfTwo = {
  content?: string;
  type?: MessagingCreateChatRoom201LastMessageBasicInfoAllOfTwoType;
};
